import type { Styles } from 'src/theme/themes';

const baseNameOrId = {
  maxWidth: '100%',
  overflow: 'hidden',
  display: 'inline-block',
  textOverflow: 'ellipsis',
};

export const styles = {
  label: {
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    userSelect: 'none',
    alignItems: 'flex-start',
  },
  name: (theme) => ({ ...baseNameOrId, color: theme.colors.neutral[700] }),
  id: (theme) => ({
    ...baseNameOrId,
    color: theme.colors.neutral[400],
  }),
  negsel: (theme) => ({
    color: theme.colors.neutral[200],
  }),
  priority: (theme) => ({
    px: theme.spacing(1),
    py: theme.spacing(0.5),
    color: theme.colors.secondary[800],
    backgroundColor: theme.colors.secondary[50],
    borderRadius: '4px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  }),
} satisfies Styles;
